<div id="unhealthyWells">
    <div class="row justify-between px-6 py-3 card-header">
        <div class="text-lg font-medium tracking-tight leading-6 truncate">
            Unhealthy Wells
        </div>
        <button (click)="
                openDialog(
                    'Unhealthy Wells',
                    'unhealthyWells',
                    'createPieChart'
                )
            ">
            <ng-container [ngTemplateOutlet]="expandIcon"></ng-container>
        </button>
    </div>

    <div class="px-6 pb-6 pt-2">
        <div class="grid grid-cols-1 md: grid-cols-2 w-full mt-6">
            <div id="pieChart"></div>
            <div id="pieChart2"></div>
        </div>
        <div class="pt-6">
            <table class="table" style="
                    width: 100%;
                    font-size: 13px;
                    border: 1.5px solid #e5e5e5;
                ">
                <thead>
                    <tr>
                        <th scope="col" colspan="2">Risk Ranking</th>
                        <th scope="col" class="greyBgColor text-center">
                            Active
                        </th>
                        <th scope="col" class="greyBgColor text-center">
                            Idle
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let row of data?.data?.riskRankingTable" [ngClass]="{
                            healthyBgColor: row.riskRanking === '0-1',
                            healthyMOCBgColor: row.riskRanking === '2',
                            unhealthyBgColor:
                                row.riskRanking === '3' &&
                                row.category !== 'Unhealthy with MOC',
                            unhealthyMOCBgColor:
                                row.riskRanking === '3' &&
                                row.category === 'Unhealthy with MOC',
                            unhealthyHighRiskBgColor: row.riskRanking === '4'
                        }">
                        <td class="text-center" [ngClass]="{
                                healthyBgColor: row.riskRanking === '0-1',
                                healthyMOCBgColor: row.riskRanking === '2',
                                unhealthyBgColor:
                                    row.riskRanking === '3' &&
                                    row.category !== 'Unhealthy with MOC',
                                unhealthyMOCBgColor:
                                    row.riskRanking === '3' &&
                                    row.category === 'Unhealthy with MOC',
                                unhealthyHighRiskBgColor:
                                    row.riskRanking === '4'
                            }">
                            {{ row.riskRanking }}
                        </td>
                        <td [ngClass]="{
                                healthyBgColor: row.riskRanking === '0-1',
                                healthyMOCBgColor: row.riskRanking === '2',
                                unhealthyBgColor:
                                    row.riskRanking === '3' &&
                                    row.category !== 'Unhealthy with MOC',
                                unhealthyMOCBgColor:
                                    row.riskRanking === '3' &&
                                    row.category === 'Unhealthy with MOC',
                                unhealthyHighRiskBgColor:
                                    row.riskRanking === '4'
                            }">
                            {{ row.category }}
                        </td>
                        <td class="greyBgColor text-center">
                            {{ row.activeCount }}
                        </td>
                        <td class="greyBgColor text-center">
                            {{ row.idleCount }}
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

        <div class="row progress-bar my-5">
            <div class="unHealthy-progress-bar text-center"
                [style.width.%]="data?.data?.summaryBar?.unhealthyPercentage">
                {{ data?.data?.summaryBar?.unhealthyPercentage }}% :
                {{ data?.data?.summaryBar?.unhealthyCount }}
            </div>
            <div class="healthy-progress-bar text-center" [style.width.%]="data?.data?.summaryBar?.healthyPercentage">
                {{ data?.data?.summaryBar?.healthyPercentage }}% :
                {{ data?.data?.summaryBar?.healthyCount }}
            </div>
        </div>
    </div>
</div>